var _path, _path2, _path3, _g, _rect, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame632(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 149,
    viewBox: "0 0 158 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_2276)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2541 0C79.0796 0 81.9053 0 84.7307 0C101.096 1.8276 110.712 10.851 113.578 27.0703C113.839 30.0746 114.067 33.0824 114.262 36.0938C116.255 37.616 117.485 39.6211 117.953 42.1094C118.368 45.1052 118.459 48.113 118.227 51.1328C117.414 55.5447 115.09 58.8714 111.254 61.1133C110.439 61.2495 109.618 61.2951 108.793 61.25C107.719 64.3095 106.216 67.1349 104.281 69.7266C102.095 79.7051 98.95 89.3665 94.8479 98.7109C92.0033 94.0907 88.0841 90.6727 83.0901 88.457C78.3867 87.0576 74.103 87.8779 70.2385 90.918C67.438 93.126 65.0681 95.7236 63.1291 98.7109C59.027 89.3665 55.8825 79.7051 53.6955 69.7266C51.7615 67.1349 50.2576 64.3095 49.1838 61.25C47.9203 61.3886 46.7355 61.1609 45.6291 60.5664C42.4493 58.202 40.4896 55.0575 39.7502 51.1328C39.5178 48.113 39.6089 45.1052 40.0237 42.1094C40.4918 39.6211 41.7223 37.616 43.7151 36.0938C43.7006 27.7985 46.1159 20.3245 50.9612 13.6719C55.85 7.4678 62.2757 4.27768 70.2385 4.10156C71.7851 2.05293 73.7902 0.685746 76.2541 0Z",
    fill: "#D11116"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.863 128.379C148.863 130.02 148.863 131.66 148.863 133.301C147.887 136.556 145.79 138.744 142.574 139.863C100.1 139.863 57.6262 139.863 15.1523 139.863C11.9363 138.744 9.83993 136.556 8.86328 133.301C8.86328 131.66 8.86328 130.02 8.86328 128.379C10.1397 120.988 11.6436 113.605 13.375 106.23C14.8127 100.701 18.3218 97.2828 23.9023 95.9766C32.487 93.6368 41.1002 91.4036 49.7422 89.2773C50.1048 89.3471 50.3782 89.5295 50.5625 89.8242C54.5448 101.225 59.3757 112.253 65.0547 122.91C66.5589 125.555 68.1995 128.107 69.9766 130.566C71.3894 125.098 72.802 119.629 74.2148 114.16C67.745 106.774 68.8388 100.804 77.4961 96.25C79.4607 95.8196 81.1924 96.2752 82.6914 97.6172C84.7827 99.07 86.3779 100.938 87.4766 103.223C87.9332 105.856 87.4777 108.317 86.1094 110.605C85.2401 111.801 84.3741 112.986 83.5117 114.16C84.9246 119.629 86.3372 125.098 87.75 130.566C93.6691 121.646 98.591 112.167 102.516 102.129C104.141 98.0574 105.691 93.9559 107.164 89.8242C107.348 89.5295 107.622 89.3471 107.984 89.2773C116.625 91.4033 125.238 93.6365 133.824 95.9766C139.405 97.2828 142.914 100.701 144.352 106.23C146.02 113.618 147.524 121.001 148.863 128.379ZM105.113 122.363C110.947 122.363 116.78 122.363 122.613 122.363C122.613 125.28 122.613 128.197 122.613 131.113C116.78 131.113 110.947 131.113 105.113 131.113C105.113 128.197 105.113 125.28 105.113 122.363Z",
    fill: "#D11116"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_362_2276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 89,
    width: 141,
    height: 51
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.863 128.379C148.863 130.02 148.863 131.66 148.863 133.301C147.887 136.556 145.79 138.744 142.574 139.863C100.1 139.863 57.6262 139.863 15.1523 139.863C11.9363 138.744 9.83993 136.556 8.86328 133.301C8.86328 131.66 8.86328 130.02 8.86328 128.379C10.1397 120.988 11.6436 113.605 13.375 106.23C14.8127 100.701 18.3218 97.2828 23.9023 95.9766C32.487 93.6368 41.1002 91.4036 49.7422 89.2773C50.1048 89.3471 50.3782 89.5295 50.5625 89.8242C54.5448 101.225 59.3757 112.253 65.0547 122.91C66.5589 125.555 68.1995 128.107 69.9766 130.566C71.3894 125.098 72.802 119.629 74.2148 114.16C67.745 106.774 68.8388 100.804 77.4961 96.25C79.4607 95.8196 81.1924 96.2752 82.6914 97.6172C84.7827 99.07 86.3779 100.938 87.4766 103.223C87.9332 105.856 87.4777 108.317 86.1094 110.605C85.2401 111.801 84.3741 112.986 83.5117 114.16C84.9246 119.629 86.3372 125.098 87.75 130.566C93.6691 121.646 98.591 112.167 102.516 102.129C104.141 98.0574 105.691 93.9559 107.164 89.8242C107.348 89.5295 107.622 89.3471 107.984 89.2773C116.625 91.4033 125.238 93.6365 133.824 95.9766C139.405 97.2828 142.914 100.701 144.352 106.23C146.02 113.618 147.524 121.001 148.863 128.379ZM105.113 122.363C110.947 122.363 116.78 122.363 122.613 122.363C122.613 125.28 122.613 128.197 122.613 131.113C116.78 131.113 110.947 131.113 105.113 131.113C105.113 128.197 105.113 125.28 105.113 122.363Z",
    fill: "#ABABAB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_362_2276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.8516 99.3945L89.6641 127.422L87.75 130.84H69.8398L67.9258 127.422L62.7305 102.812L77.7695 93.1055L91.8516 99.3945Z",
    fill: "#ABABAB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 122,
    width: 18,
    height: 9,
    fill: "#ABABAB"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79,
    cy: 144.5,
    rx: 69,
    ry: 4.5,
    fill: "url(#paint0_radial_362_2276)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_362_2276",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79 144.5) scale(69 4.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_2276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white",
    transform: "translate(9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame632);
export default __webpack_public_path__ + "static/media/Frame 63 (2).3262f42cb41883e65cfa1c5999b300d4.svg";
export { ForwardRef as ReactComponent };